import { MODULE } from '@core/configs';
import { environment } from '@environments/environment';

export const APP_CONFIG = {
  module: MODULE.careposiConsole,
  apiBaseUrl: '',
  tokenUrl: '',
  inActiveTime: 30,
  envName: environment.envName,
};

export const HttpStatus = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
};
